export enum PieChartTypeEnum {
    AssetType = 'assetType',
    AssetDistribution = 'assetDistribution',
    Currency = 'currency',
    Country = 'country',
    Sector = 'sector',
    Broker = 'broker',
}
